"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { BookOpen, Layers, Users, User, FileText, Handshake } from "lucide-react";
export default function OrganizationalCategories() {
  const categories = [{
    id: 1,
    icon: BookOpen,
    title: "Profil & Sejarah",
    description: "Profil, sejarah, visi-misi, lambang, makna dan dokumentasi organisasi.",
    link: "/ProfileConstitutionPage"
  }, {
    id: 2,
    icon: Layers,
    title: "Struktur & Hierarki",
    description: "Lihat struktur organisasi dan MPN, MPW, MPC, PAC, Ranting hingga Anak Ranting.",
    link: "/OrganizationStructurePage"
  }, {
    id: 3,
    icon: Users,
    title: "Badan, Lembaga & Sayap",
    description: "Informasi badan, lembaga dan sayap organisasi di tingkat nasional dan wilayah.",
    link: "/UnitAndBodyPage"
  }, {
    id: 4,
    icon: User,
    title: "Tokoh & Senior",
    description: "Profil tokoh, senior, pendiri dan pengurus Pemuda Pancasila dari masa ke masa.",
    link: "#"
  }, {
    id: 5,
    icon: FileText,
    title: "Warta & Agenda",
    description: "Berita, agenda, kegiatan, siaran pers dan dokumentasi organisasi.",
    link: "/PPZonePage"
  }, {
    id: 6,
    icon: Handshake,
    title: "Layanan Organisasi",
    description: "Layanan keorganisasian, verifikasi, pengaduan, kritik kegiatan dan dokumen.",
    link: "/ServicesPage"
  }];
  return <section id="organizationalcategories" className="w-full bg-background py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, i) => {
          const IconComponent = category.icon;
          return <div key={category.id} className="zona-pp-card bg-card rounded-lg p-6 border border-border shadow-sm hover:shadow-md transition-shadow duration-300" data-index={i}>
                <div className="flex flex-col gap-4">
                  <div className="inline-flex h-16 w-16 items-center justify-center rounded-lg bg-primary text-primary-foreground transition-transform duration-300 group-hover:scale-110">
                    <IconComponent className="h-8 w-8" />
                  </div>
                  <div className="flex flex-col gap-2">
                    <h3 className="font-default text-lg font-semibold text-foreground">
                      {category.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {category.description}
                    </p>
                  </div>
                  <div className="mt-auto pt-4">
                    <Link to={category.link}>
                      <Button variant="outline" className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300">
                        Lihat Selengkapnya →
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}